import React from 'react';
import { useIntl } from 'react-intl';

import { useEmbedMode } from '../../../../features';

import './style.scss';

export default function AppGalleryBanner() {
  const { formatMessage } = useIntl();
  const { isEmbeddedMode } = useEmbedMode();

  return (
    <div className="main-page_top-block" hidden={isEmbeddedMode}>
      <div className="main-title-block">
        <h1 className="main-title-block__title">
          {formatMessage({ id: 'app_gallery_main_title' })}
        </h1>
      </div>
    </div>
  );
}
